import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";
import { DatosFacturacionComponent } from "../../../../catalogos/items/clientes/edit/componentes/datosfacturacion";
import { EntregaItemComp } from "./item";
import { DatosFacturacionClienteEditModal } from "./datosfacturacionmodal";
import { DatosFacturacion } from "../../../../catalogos/items/clientes/edit/componentes/types";

interface Props {
    datosViaje: models.DatosViajeZEApp;
    idDireccionDestino: number;
    onChange: (x: models.DatosViajeZEApp) => void;
}

const RealizarButton = kea.defaultProps(kea.Button, { children: "Realizar entrega", style: "success", iconClass: fa("plus") });
const ModificarDatosFacturacionButton = kea.defaultProps(kea.Button, { children: "Modificar datos de facturación del cliente", style: "success", iconClass: fa("pencil") });

/**Listado de las entregas de un destino */
class ListEntregasCompNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    datosViaje = (props: Props) => props.datosViaje;
    idDireccion = (props: Props) => props.idDireccionDestino;
    items = createSelectorRx(this.datosViaje, (datosViaje) => datosViaje.Entregas);

    onRegresar = () => {
        history.go("../");
    }

    onModificarDatosFacturacion = async () => {
        const datosViaje = this.datosViaje(this.props);
        const result = await this.modalManager.showModal(DatosFacturacionClienteEditModal, datosViaje.TipoPersonaClienteDestino, { ...datosViaje.DatosFacturacionCliente, IdDatosFacturacionColonia: datosViaje.IdColoniaFacturacionCliente } as DatosFacturacion);
        if (result.result) {
            await resources.Cliente.ModificarDatosFacturacion(datosViaje.IdClienteDestino, result.value);
            const viejo = this.props.datosViaje;
            const nuevo: Partial<models.DatosViajeZEApp> = {
                DatosFacturacionCliente: {
                    CorreoFacturacion: result.value.CorreoFacturacion,
                    Direccion: result.value.Direccion,
                    NoCuentaOrdenante: result.value.NoCuentaOrdenante,
                    NumeroRegistroIdentidadFiscal: result.value.NumeroRegistroIdentidadFiscal,
                    ResidenciaFiscal: result.value.ResidenciaFiscal,
                    CodigoRegimenFiscal: result.value.CodigoRegimenFiscal,
                    NombreFiscal: result.value.NombreFiscal
                },
                IdColoniaFacturacionCliente: result.value.IdDatosFacturacionColonia
            };
            await this.props.onChange({ ...viejo, ...nuevo });
            await kea.message("Datos facturación modificados", "Se han actualizado los datos de facturación del cliente", "success");
        }
    }

    onAgregar = async () => {
        const idDireccion = this.idDireccion(this.props);
        const datosViaje = this.datosViaje(this.props);
        const validacion = await resources.ViajeZEApp.PuedeAgregarEntrega(datosViaje.IdViajeZE, idDireccion);
        if (validacion) {
            if (await kea.yesno("Realizar entrega", "¿Agregar nueva entrega realizada?")) {
                history.go("./new");
            }
        }
    }

    render() {
        const items = this.items(this.props);
        const datosViaje = this.datosViaje(this.props);
        return (
            <div>
                <kea.Title titulo={
                    <span>
                        Entregas en
                        <b>{" "}{datosViaje.DescripcionCorta}</b>
                    </span>
                } onRegresar={this.onRegresar}  >
                    <RealizarButton onClick={this.onAgregar} />
                </kea.Title>
                <kea.Panel title="Destino" style="primary">
                    <label>Dirección:</label>{" "}{datosViaje.Descripcion}
                    <br />
                    <label>Cliente: </label>{" "}{datosViaje.NombreCliente}
                    <br />
                    <label>Guias procesadas/total:</label>{" "}{datosViaje.CantGuiasProcesadas}{"/"}{datosViaje.CantGuias}
                    <br />
                    <label>Paquetes:</label>{" "}{datosViaje.CantPaquetes}
                    <br />
                    <label>Sobres:</label>{" "}{datosViaje.CantSobres}
                    <br />
                    <label>Importe a pagar:</label>{" "}{kea.formatCurrency(datosViaje.ImportePagar)}
                    <br />
                    <label>Teléfono: </label>{" "}
                    {
                        datosViaje.TelefonoCliente &&
                        <a href={"tel:" + datosViaje.TelefonoCliente}> <i className={fa("phone")} /> {"  "} {datosViaje.TelefonoCliente} {"  "} Llamar</a>
                    }
                    {datosViaje.DatosFacturacionCliente != null &&
                        <>
                            <h4>Datos de facturación</h4>
                            <label>Correo de facturación:</label>{" "}{datosViaje.DatosFacturacionCliente.CorreoFacturacion}
                            <br />
                            <label>Número registro de identidad fiscal:</label>{" "}{datosViaje.DatosFacturacionCliente.NumeroRegistroIdentidadFiscal}
                            <br />
                            <label>Codigo postal domicilio fiscal:</label>{" "}{datosViaje.DatosFacturacionCliente.ResidenciaFiscal}
                            <br />
                            <label>No. Cuenta ordenante:</label>{" "}{datosViaje.DatosFacturacionCliente.NoCuentaOrdenante}
                            <br />
                            <label>Dirección de facturación:</label>{" "}{datosViaje.DescripcionDireccionFacturacion}
                            <br />
                            {
                                datosViaje.ImportePagar > 0 &&
                                <div className="alert alert-warning">
                                    <div className="btn-group">
                                        <ModificarDatosFacturacionButton onClick={this.onModificarDatosFacturacion} />
                                    </div>
                                </div>
                            }
                        </>
                    }
                </kea.Panel>
                {items.length == 0 &&
                    <div className="alert alert-primary">
                        <label>Sin entregas</label>
                        <br />
                        Este destino aún no tiene ninguna entrega realizada
                    </div>
                }
                {items.map(x => <EntregaItemComp key={x.IdRegistro} value={x} />)}
                {this.modalManager.component}
            </div>
        )
    }
}

const ListEntregasCompRx = componentToRx(ListEntregasCompNoRx);

interface PropsLista {
    idDireccionDestino: number;
}
interface State {
    value?: models.DatosViajeZEApp;
}
export class ListEntregasComp extends React.PureComponent<PropsLista, State> {
    constructor(props: PropsLista) {
        super(props);
        this.state = {};
    }

    idDireccionDestino = (props: PropsLista, state: State) => props.idDireccionDestino;
    idViajeZE = (props: PropsLista, state: State) => observeResource(resources.ViajeZEApp.ObtenerIdViajeZEUsuario);
    datosViajeFromResource = createSelectorRx(this.idViajeZE, this.idDireccionDestino, (idViajeZE, idDireccionDestino) =>
        observeResource(resources.ViajeZEApp.ObtenerDatosViajeZEApp, idViajeZE!, idDireccionDestino));

    valueFromState = (props: PropsLista, state: State) => state.value;

    value = createSelectorRx(this.valueFromState, this.datosViajeFromResource, (state, resource) => state || resource);

    onChange = (value: models.DatosViajeZEApp) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const value = this.value(this.props, this.state);
        const idDireccionDestino = this.idDireccionDestino(this.props, this.state);
        return <div>
            <ListEntregasCompRx idDireccionDestino={idDireccionDestino} datosViaje={value} onChange={this.onChange} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entregas/listmem.tsx